import { getCompanyName } from "../../lib/utilities/Constants";

const getBrandImages = () => {
  const companyName = getCompanyName();

  return BRAND_IMAGES[companyName as keyof typeof BRAND_IMAGES];
};

const BRAND_IMAGES = {
  TYPTAP: {
    BRANDING_BACKGROUND_IMAGE: require(`../assets/images/branding/TYPTAP/bg-web.png`),
    BRANDING_BACKGROUND_GREY: require(`../assets/images/branding/TYPTAP/bg-web-gray.png`),
    LOGO_IMAGE: require(`../assets/images/branding/TYPTAP/company-logo.png`),
    LOGO: require(`../assets/images/branding/TYPTAP/company-logo-white.png`),
    LOGO_TRANSPARENT: require(`../assets/images/branding/TYPTAP/company-logo-icon.png`),

    // Tiles and images
    CLAIM_PAEG_IMAGE: require(`../assets/images/tiles/TYPTAP/claim-page-image.png`),
    HOME_ICON: require(`../assets/images/tiles/TYPTAP/home-tile-image.png`),
    AGENT_PAEG_IMAGE: require(`../assets/images/tiles/TYPTAP/your-agent.png`),
    PDF_FILE_ICON: require(`../assets/images/tiles/TYPTAP/pdf-file.png`),
    APP_ICON: require("../assets/images/branding/TYPTAP/company-app-icon.png"),
    PAYMENT_ICON: require("../assets/images/branding/TYPTAP/payment-status.png"),
    // Payments icons
    CARD_PAYMENTS_ICON: require("../assets/images/branding/TYPTAP/cardIcon.png"),
    BANK_PAYMENTS_ICON: require("../assets/images/branding/TYPTAP/bankIcon.png"),
    MAIL_PAYMENTS_ICON: require("../assets/images/branding/TYPTAP/messageIcon.png"),
    SHAREABLE_ICON: require("../assets/images/branding/TYPTAP/Shareable.png"),
    SHAREABLE_STAGE_ICON: require("../assets/images/branding/TYPTAP/ShareableStage.png"),
    SHAREABLE_LINKS_ICON: require("../assets/images/branding/TYPTAP/AppShareImages.png"),
    // CORE DESIGN BG IMAGE
    POLICY_ACTION_BG: require("../assets/images/branding/CORE/policyActionBg.png"),
  },
  HCPCI: {
    BRANDING_BACKGROUND_IMAGE: require(`../assets/images/branding/HCPCI/bg-web.png`),
    BRANDING_BACKGROUND_GREY: require(`../assets/images/branding/HCPCI/bg-web-gray.png`),
    LOGO_IMAGE: require(`../assets/images/branding/HCPCI/company-logo.png`),
    LOGO: require(`../assets/images/branding/HCPCI/company-logo-white.png`),
    LOGO_TRANSPARENT: require(`../assets/images/branding/HCPCI/company-logo-icon.png`),
    // Payments icons
    CARD_PAYMENTS_ICON: require("../assets/images/branding/TYPTAP/cardIcon.png"),
    BANK_PAYMENTS_ICON: require("../assets/images/branding/TYPTAP/bankIcon.png"),
    MAIL_PAYMENTS_ICON: require("../assets/images/branding/TYPTAP/messageIcon.png"),

    // Tiles and images
    CLAIM_PAEG_IMAGE: require(`../assets/images/tiles/HCPCI/claim-page-image.png`),
    HOME_ICON: require(`../assets/images/tiles/HCPCI/home-tile-image.png`),
    AGENT_PAEG_IMAGE: require(`../assets/images/tiles/HCPCI/your-agent.png`),
    PDF_FILE_ICON: require(`../assets/images/tiles/HCPCI/pdf-file.png`),
    APP_ICON: require("../assets/images/branding/HCPCI/company-app-icon.png"),
    PAYMENT_ICON: require("../assets/images/branding/HCPCI/payment-status.png"),
    SHAREABLE_ICON: require("../assets/images/branding/TAILROW/Shareable.png"),
    SHAREABLE_STAGE_ICON: require("../assets/images/branding/TAILROW/shareableStage.png"),
    SHAREABLE_LINKS_ICON: require("../assets/images/branding/TAILROW/AppShareImages.png"),
    // CORE DESIGN BG IMAGE
    POLICY_ACTION_BG: require("../assets/images/branding/CORE/policyActionBg.png"),
  },
  TAILROW: {
    BRANDING_BACKGROUND_IMAGE: require(`../assets/images/branding/TAILROW/bg-web.png`),
    BRANDING_BACKGROUND_GREY: require(`../assets/images/branding/TAILROW/bg-web-gray.png`),
    LOGO_IMAGE: require(`../assets/images/branding/TAILROW/company-logo.png`),
    LOGO: require(`../assets/images/branding/TAILROW/company-logo-white.png`),
    LOGO_TRANSPARENT: require(`../assets/images/branding/TYPTAP/company-logo-icon.png`),

    // Tiles and images
    CLAIM_PAEG_IMAGE: require(`../assets/images/tiles/TAILROW/claim-page-image.png`),
    HOME_ICON: require(`../assets/images/tiles/TAILROW/home-tile-image.png`),
    AGENT_PAEG_IMAGE: require(`../assets/images/tiles/TAILROW/your-agent.png`),
    PDF_FILE_ICON: require(`../assets/images/tiles/TAILROW/pdf-file.png`),
    APP_ICON: require("../assets/images/branding/TAILROW/company-app-icon.png"),
    PAYMENT_ICON: require("../assets/images/branding/TAILROW/payment-status.png"),
    // Payments icons
    CARD_PAYMENTS_ICON: require("../assets/images/branding/TAILROW/cardIcon.png"),
    BANK_PAYMENTS_ICON: require("../assets/images/branding/TAILROW/bankIcon.png"),
    MAIL_PAYMENTS_ICON: require("../assets/images/branding/TAILROW/messageIcon.png"),
    SHAREABLE_ICON: require("../assets/images/branding/TAILROW/Shareable.png"),
    SHAREABLE_STAGE_ICON: require("../assets/images/branding/TAILROW/shareableStage.png"),
    SHAREABLE_LINKS_ICON: require("../assets/images/branding/TAILROW/AppShareImages.png"),
    // CORE DESIGN BG IMAGE
    POLICY_ACTION_BG: require("../assets/images/branding/CORE/policyActionBg.png"),
  },
  PRAXIS: {
    BRANDING_BACKGROUND_IMAGE: null,
    BRANDING_BACKGROUND_GREY: null,
    LOGO_IMAGE: require(`../assets/images/branding/PRAXIS/company-logo.png`),
    LOGO: require(`../assets/images/branding/PRAXIS/company-logo-white.png`),
    LOGO_TRANSPARENT: require(`../assets/images/branding/PRAXIS/company-logo-icon.png`),

    // Tiles and images
    CLAIM_PAEG_IMAGE: require(`../assets/images/tiles/PRAXIS/claim-page-image.png`),
    HOME_ICON: require(`../assets/images/tiles/PRAXIS/home-tile-image.png`),
    AGENT_PAEG_IMAGE: require(`../assets/images/tiles/PRAXIS/your-agent.png`),
    PDF_FILE_ICON: require(`../assets/images/tiles/PRAXIS/pdf-file.png`),
    APP_ICON: require("../assets/images/branding/PRAXIS/company-app-icon.png"),
    PAYMENT_ICON: require("../assets/images/branding/PRAXIS/payment-status.png"),
    // Payments icons
    CARD_PAYMENTS_ICON: require("../assets/images/branding/PRAXIS/card-icon.png"),
    BANK_PAYMENTS_ICON: require("../assets/images/branding/PRAXIS/bank-icon.png"),
    MAIL_PAYMENTS_ICON: require("../assets/images/branding/PRAXIS/mail-icon.png"),
    SHAREABLE_ICON: require("../assets/images/branding/TAILROW/Shareable.png"),
    SHAREABLE_STAGE_ICON: require("../assets/images/branding/TAILROW/shareableStage.png"),
    SHAREABLE_LINKS_ICON: require("../assets/images/branding/TAILROW/AppShareImages.png"),
    // CORE DESIGN BG IMAGE
    POLICY_ACTION_BG: require("../assets/images/branding/CORE/policyActionBg.png"),
  },
  CORE: {
    BRANDING_BACKGROUND_IMAGE: null,
    BRANDING_BACKGROUND_GREY: null,
    LOGO_IMAGE: require(`../assets/images/branding/CORE/company-logo.png`),
    LOGO: require(`../assets/images/branding/CORE/company-logo-white.png`),
    LOGO_TRANSPARENT: require(`../assets/images/branding/CORE/company-app-icon.png`),

    // Tiles and images
    CLAIM_PAEG_IMAGE: require(`../assets/images/tiles/CORE/claim-page-image.png`),
    HOME_ICON: require(`../assets/images/tiles/PRAXIS/home-tile-image.png`),
    AGENT_PAEG_IMAGE: require(`../assets/images/tiles/CORE/your-agent.png`),
    PDF_FILE_ICON: require(`../assets/images/tiles/CORE/pdf-file.png`),
    APP_ICON: require("../assets/images/branding/CORE/company-app-icon.png"),
    PAYMENT_ICON: require("../assets/images/branding/CORE/payment-status.png"),
    // Payments icons
    CARD_PAYMENTS_ICON: require("../assets/images/branding/CORE/card-icon.png"),
    BANK_PAYMENTS_ICON: require("../assets/images/branding/CORE/bank-icon.png"),
    MAIL_PAYMENTS_ICON: require("../assets/images/branding/CORE/mail-icon.png"),
    SHAREABLE_ICON: require("../assets/images/branding/TYPTAP/Shareable.png"),
    SHAREABLE_STAGE_ICON: require("../assets/images/branding/CORE/ShareableStage.png"),
    SHAREABLE_LINKS_ICON: require("../assets/images/branding/CORE/AppShareImages.png"),
    // CORE DESIGN BG IMAGE
    POLICY_ACTION_BG: require("../assets/images/branding/CORE/policyActionBg.png"),
  },
};

// notification icons
const BELL_BLUE_ICON = require(`../assets/images/notification/bell-blue.png`);
const BELL_GREY_ICON = require(`../assets/images/notification/bell-grey.png`);
const DOCS_BLUE_ICON = require(`../assets/images/notification/doc-blue.png`);
const DOCS_GREY_ICON = require(`../assets/images/notification/doc-grey.png`);
const DOLLAR_BLUE_ICON = require(`../assets/images/notification/dollar-blue.png`);
const DOLLAR_GREY_ICON = require(`../assets/images/notification/dollar-grey.png`);
const NOTIFICAITON_ICON = require(`../assets/images/notification/notification-bell.png`);

// Action Tile Icons
const DOCS_ACTION_TILE_ICON = require(`../assets/images/icons/docs-gray-icon.png`);
const AGENT_ACTION_TILE_ICON = require(`../assets/images/icons/call-gray-icon.png`);
const MAKE_PAYMENT_ACTION_TILE_ICON = require(`../assets/images/icons/dollar-gray-icon.png`);
const CLAIM_ACTION_TILE_ICON = require(`../assets/images/icons/claim-gray-icon.png`);

// icons
const DOWN_ARROW_ICON = require(`../assets/images/icons/dropdown-arrow.png`);
const UP_ARROW_ICON = require(`../assets/images/icons/arrow-up.png`);
const DROP_DOWN_ARROW_ICON = require(`../assets/images/icons/drop-down-arrow.png`);
const DROPDOWN_HOLLOW = require(`../assets/images/icons/dropdown-hollow.png`);
const DROP_UP_ARROW_ICON = require(`../assets/images/icons/arrow-dropdown-up.png`);
const NEXT_GRAY_ICON = require(`../assets/images/icons/arrow-next-grey.png`);
const NEXT_ICON = require(`../assets/images/icons/arrow-next.png`);
const PREV_ICON = require(`../assets/images/icons/arrow-prev.png`);
const BACK_ICON = require(`../assets/images/icons/back.png`);
const BACK_ICON_WHITE = require(`../assets/images/icons/arrow-prev-white.png`);
const DROPDOWN_ARROW_DARK = require(`../assets/images/icons/dropdown-hollow-dark.png`);
const CALL_ICON = require(`../assets/images/icons/Call.png`);
const CHECK_ICON = require(`../assets/images/icons/check.png`);
const CROSS_ICON = require(`../assets/images/icons/cross-icon.png`);
const CROSS_ICON_WHITE = require(`../assets/images/icons/cross-icon-white.png`);
const RESET_ICON = require(`../assets/images/icons/reset-password-icon.png`);
const DELETE_ICON = require(`../assets/images/icons/delete-account-icon.png`);
const ABOUT_ICON = require(`../assets/images/icons/about-us-icon.png`);
const FAQ_ICON = require(`../assets/images/icons/faq-icon.png`);
const BLOG_ICON = require(`../assets/images/icons/blog-icon.png`);
const PRIVACY_ICON = require(`../assets/images/icons/privacy-policy-icon.png`);
const TERMS_ICON = require(`../assets/images/icons/terms-icon.png`);
const DELETE_ACCOUNT_ICON = require(`../assets/images/icons/delete-account.png`);
const EMAIL_ICON = require(`../assets/images/icons/email.png`);
const ERROR_ICON = require(`../assets/images/icons/error-icon.png`);
const SUCCESS_ICON = require(`../assets/images/icons/success-icon.png`);
const FAX_ICON = require(`../assets/images/icons/fax.png`);
const INBOX_IMAGE = require(`../assets/images/icons/inbox.png`);
const INFO_ICON = require(`../assets/images/icons/info-icon.png`);
const LOCATION_ICON = require(`../assets/images/icons/location.png`);
const MANAGE_ACCOUNT_ICON = require(`../assets/images/icons/manage-account.png`);
const PROFILE_ICON = require(`../assets/images/icons/profile.png`);
const REFRESH_ICON = require(`../assets/images/icons/refresh.png`);
const RESET_PASSWORD_ICON = require(`../assets/images/icons/ResetPassword.png`);
const SIGNOUT_ICON = require(`../assets/images/icons/signout.png`);
const SIGNOUT_CUSTOM_ICON = require(`../assets/images/icons/signout-icon.png`);
const VERIFIED_ICON = require(`../assets/images/icons/verified.png`);
const BANK_ICON = require(`../assets/images/icons/bankIcon.png`);
const CARD_ICON = require(`../assets/images/icons/cardIcon.png`);
const MAIL_ICON = require(`../assets/images/icons/mailIcon.png`);
const DOWNLOAD_ICON = require(`../assets/images/icons/downloadIcon.png`);
const APP_STORE_ICON = require(`../assets/images/icons/appStore.png`);
const PLAY_STORE_ICON = require(`../assets/images/icons/playStore.png`);
const OR_SEPERATOR_ICON = require(`../assets/images/icons/orSeperator.png`);
const DOLLOR_WHITE_ICON = require(`../assets/images/icons/dollor-white-icon.png`);
const CLAIM_WHITE_ICON = require(`../assets/images/icons/claim-white-icon.png`);
const DOCS_WHITE_ICON = require(`../assets/images/icons/docs-white-icon.png`);
const AGENT_WHITE_ICON = require(`../assets/images/icons/agent-white-icon.png`);
const DOLLOR_FADDED_ICON = require(`../assets/images/icons/ic_billing.png`);
const CLAIM_FADDED_ICON = require(`../assets/images/icons/ic_report.png`);
const DOCS_FADDED_ICON = require(`../assets/images/icons/ic_docs.png`);
const AGENT_FADDED_ICON = require(`../assets/images/icons/ic_call.png`);
const ALERT_ICON = require(`../assets/images/icons/alert-icon.png`);
const WEB_ICON = require(`../assets/images/icons/web-icon.png`);
const ANDROID_ICON = require(`../assets/images/icons/android-icon.png`);
const IOS_ICON = require(`../assets/images/icons/ios-icon.png`);

const {
  BRANDING_BACKGROUND_IMAGE,
  BRANDING_BACKGROUND_GREY,
  CLAIM_PAEG_IMAGE,
  AGENT_PAEG_IMAGE,
  HOME_ICON,
  LOGO,
  LOGO_IMAGE,
  LOGO_TRANSPARENT,
  PDF_FILE_ICON,
  APP_ICON,
  PAYMENT_ICON,
  MAIL_PAYMENTS_ICON,
  CARD_PAYMENTS_ICON,
  BANK_PAYMENTS_ICON,
  SHAREABLE_ICON,
  SHAREABLE_STAGE_ICON,
  SHAREABLE_LINKS_ICON,
  POLICY_ACTION_BG,
} = getBrandImages();

export {
  DOLLOR_FADDED_ICON,
  CLAIM_FADDED_ICON,
  DOCS_FADDED_ICON,
  AGENT_FADDED_ICON,
  ALERT_ICON,
  WEB_ICON,
  ANDROID_ICON,
  IOS_ICON,
  AGENT_WHITE_ICON,
  DOLLOR_WHITE_ICON,
  DOCS_WHITE_ICON,
  CLAIM_WHITE_ICON,
  POLICY_ACTION_BG,
  BANK_ICON,
  CARD_ICON,
  MAIL_ICON,
  DROP_UP_ARROW_ICON,
  DROP_DOWN_ARROW_ICON,
  DROPDOWN_HOLLOW,
  LOGO_TRANSPARENT,
  BRANDING_BACKGROUND_IMAGE,
  BRANDING_BACKGROUND_GREY,
  CLAIM_PAEG_IMAGE,
  AGENT_PAEG_IMAGE,
  HOME_ICON,
  LOGO,
  LOGO_IMAGE,
  VERIFIED_ICON,
  INFO_ICON,
  PDF_FILE_ICON,
  NEXT_ICON,
  PREV_ICON,
  DOCS_GREY_ICON,
  DOCS_BLUE_ICON,
  DOLLAR_GREY_ICON,
  DOLLAR_BLUE_ICON,
  BELL_GREY_ICON,
  BELL_BLUE_ICON,
  UP_ARROW_ICON,
  CHECK_ICON,
  DOWN_ARROW_ICON,
  FAX_ICON,
  LOCATION_ICON,
  CLAIM_ACTION_TILE_ICON,
  AGENT_ACTION_TILE_ICON,
  DOCS_ACTION_TILE_ICON,
  MAKE_PAYMENT_ACTION_TILE_ICON,
  MANAGE_ACCOUNT_ICON,
  NEXT_GRAY_ICON,
  EMAIL_ICON,
  RESET_PASSWORD_ICON,
  SIGNOUT_ICON,
  SIGNOUT_CUSTOM_ICON,
  DELETE_ACCOUNT_ICON,
  REFRESH_ICON,
  ERROR_ICON,
  SUCCESS_ICON,
  NOTIFICAITON_ICON,
  PROFILE_ICON,
  BACK_ICON,
  BACK_ICON_WHITE,
  DROPDOWN_ARROW_DARK,
  CROSS_ICON,
  CROSS_ICON_WHITE,
  RESET_ICON,
  DELETE_ICON,
  ABOUT_ICON,
  FAQ_ICON,
  BLOG_ICON,
  PRIVACY_ICON,
  TERMS_ICON,
  INBOX_IMAGE,
  CALL_ICON,
  APP_ICON,
  PAYMENT_ICON,
  MAIL_PAYMENTS_ICON,
  CARD_PAYMENTS_ICON,
  BANK_PAYMENTS_ICON,
  DOWNLOAD_ICON,
  SHAREABLE_ICON,
  SHAREABLE_LINKS_ICON,
  APP_STORE_ICON,
  PLAY_STORE_ICON,
  OR_SEPERATOR_ICON,
  SHAREABLE_STAGE_ICON,
};
